import { render } from "./DashboardPurchaseHistoryShow.vue?vue&type=template&id=69442a7a&scoped=true"
import script from "./DashboardPurchaseHistoryShow.vue?vue&type=script&lang=js"
export * from "./DashboardPurchaseHistoryShow.vue?vue&type=script&lang=js"

import "./DashboardPurchaseHistoryShow.vue?vue&type=style&index=0&id=69442a7a&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69442a7a"]])

export default __exports__